<template functional>
  <small
    class="mtx-badge text-center"
    v-bind="data.attrs"
    :class="[$options.bgClass(props.variant), data.staticClass, data.class]"
  >
    <slot />
  </small>
</template>

<script>
export default {
  props: {
    variant: {
      type: String
    }
  },

  bgClass(variant) {
    const classMap = {
      success: "bg-green color-dark",
      warning: "bg-yellow color-dark",
      error: "bg-red",
      grey: "bg-grey color-dark"
    }
    return classMap[variant] || "bg-grey color-dark"
  }
}
</script>

<style lang="scss">
.mtx-badge {
  display: inline-block;
  border-radius: rem(100px);
  padding: rem(2px $size1);
  font-weight: 700;
}
</style>
